import { patchDiagnostics } from '../lib/diagnostics';

/**
 * Device enumeration, purely so the admin view can show which camera and mic
 * are actually in use. Labels are only populated after a permission grant, so
 * call this once the streams are live.
 */

export interface DeviceInfo {
  deviceId: string;
  label: string;
  kind: MediaDeviceKind;
}

export async function listDevices(): Promise<DeviceInfo[]> {
  if (!navigator.mediaDevices?.enumerateDevices) return [];
  try {
    const devices = await navigator.mediaDevices.enumerateDevices();
    return devices.map((d) => ({
      deviceId: d.deviceId,
      label: d.label || '(unlabelled)',
      kind: d.kind,
    }));
  } catch {
    return [];
  }
}

/** Reads the settings off the live camera track the AR module opened. */
export function reportCameraFromCanvasStream(canvas: HTMLCanvasElement): void {
  // The AR module owns the camera track and we do not reach inside it, so the
  // most we can honestly report is the render target size. Explicit device IDs
  // come from config on the kiosk.
  patchDiagnostics({
    cameraLabel: `render target ${canvas.width}x${canvas.height}`,
  });
}

export async function refreshDeviceDiagnostics(configuredCameraId?: string): Promise<void> {
  const devices = await listDevices();
  const cameras = devices.filter((d) => d.kind === 'videoinput');
  const chosen = configuredCameraId
    ? cameras.find((c) => c.deviceId === configuredCameraId)
    : cameras[0];
  if (chosen) {
    patchDiagnostics({ cameraDeviceId: chosen.deviceId, cameraLabel: chosen.label });
  }
}
